import type { NewsletterApiConfig } from '../../core/js/newsletter-api/types.js';

import { initNewsletterApi } from '../../core/js/newsletter-api/index.js';

const newsletterApiConfig = {
  baseUrl: 'https://lambdas.ma.schibsted.digital/newsletter-braze-api',
  disableCache: false,
} satisfies NewsletterApiConfig;

export const newsletterApi = initNewsletterApi(newsletterApiConfig);
